import React from 'react';
import { Modal } from 'react-bootstrap';
import './styles.css';

export default function ModalResgateIndisponivel({ show, onHide }) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Body className="modal-resgate-indisponivel-body">
                <div className="d-flex flex-column align-items-center justify-content-center p-5">
                    <div className="modal-icon-warning">
                        <i className="fas fa-exclamation-triangle"></i>
                    </div>
                    <h5 className="modal-message text-center">
                        Resgates temporariamente indisponíveis
                    </h5>
                    <button
                        type="button"
                        className="btn-primario w-100 mt-3"
                        onClick={onHide}
                    >
                        OK
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
}

